import styled from 'styled-components/macro';

export const ImageWrapper = styled.div`
  overflow: hidden;
  position: relative;
`;
